export class Agrupador {
    static Operadora: Agrupador = new Agrupador(1, 'Operadora')
    static Estabelecimento: Agrupador = new Agrupador(
        2,
        'Estabelecimento'
    )
    
    id: number
    descricao: string

    constructor(id: number, descricao: string) {
        this.id = id
        this.descricao = descricao
    }
}


// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/agrupador.enum.ts